var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldsignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#FE4901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1552 26.1845L21.8625 37.3856C21.7006 37.8129 21.3042 38.0155 20.9135 37.9991C20.5562 37.9827 20.2045 37.78 20.0538 37.3911L10.8319 13.614C10.7482 13.4004 10.8431 13.2087 10.9994 13.1101C11.1557 13.0115 11.3734 13.006 11.5353 13.1703L19.8473 21.5014C19.3784 22.8378 19.9924 24.4701 21.7341 25.0068C22.1193 25.1273 22.5435 25.1328 22.9287 25.0178C25.1616 24.355 25.597 21.8629 24.2294 20.4935C23.4813 19.7431 22.4095 19.5459 21.4773 19.8746L13.143 11.5162C12.9811 11.3518 12.9867 11.1382 13.0927 10.9903C13.1932 10.837 13.3942 10.7493 13.6063 10.8315L37.3923 20.0937C37.7998 20.2525 38.0008 20.614 38.0008 20.9755C38.0008 21.337 37.7942 21.6985 37.3867 21.8574L26.1552 26.1845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldsignIcon);
export default __webpack_public_path__ + "static/media/boldsign_icon.a3140519c0e229c2ea161f23a3e898c9.svg";
export { ForwardRef as ReactComponent };